/**
 * Primary language subtags that typically use right-to-left UI (expand when adding RTL locales).
 */
const RTL_LANGUAGE_SUBTAGS = new Set([
  'ar',
  'he',
  'fa',
  'ur',
  'dv',
  'yi',
  'ps',
  'sd',
  'ckb',
]);

/**
 * Whether a BCP 47 locale string should use RTL layout (`dir="rtl"`).
 */
export function isRtlLocale(locale: string): boolean {
  if (!locale) return false;
  const primary =
    locale.replaceAll('_', '-').split('-')[0]?.toLowerCase() ?? '';
  return RTL_LANGUAGE_SUBTAGS.has(primary);
}
